import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show, SignIn, SignUp } from "@clerk/react";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { Toaster } from "@/components/ui/sonner";
import { CookieConsent } from "@/components/legal/CookieConsent";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import AppShell from "@/components/app/AppShell";
import Dashboard from "@/pages/Dashboard";
import Integrations from "@/pages/Integrations";
import Billing from "@/pages/Billing";
import Emails from "@/pages/Emails";
import AdminUsage from "@/pages/AdminUsage";
import AlertSettings from "@/pages/AlertSettings";
import PaymentResult from "@/pages/PaymentResult";
import Terms from "@/pages/Terms";
import Account from "@/pages/Account";
import Team from "@/pages/Team";
import Join from "@/pages/Join";

const Protected = ({ children }) => (
  <>
    <Show when="signed-in">{children}</Show>
    <Show when="signed-out"><Navigate to="/sign-in" replace /></Show>
  </>
);

const Home = () => (
  <>
    <Show when="signed-in"><Navigate to="/app" replace /></Show>
    <Show when="signed-out"><Landing /></Show>
  </>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ClerkAuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/join" element={<Join />} />
            <Route path="/sign-in/*" element={<AuthPage><SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp /></AuthPage>} />
            <Route path="/sign-up/*" element={<AuthPage><SignUp routing="path" path="/sign-up" signInUrl="/sign-in" /></AuthPage>} />
            <Route path="/app" element={<Protected><AppShell /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="integrations" element={<Integrations />} />
              <Route path="billing" element={<Billing />} />
              <Route path="emails" element={<Emails />} />
              <Route path="admin/usage" element={<AdminUsage />} />
              <Route path="alerts" element={<AlertSettings />} />
              <Route path="account" element={<Account />} />
              <Route path="team" element={<Team />} />
            </Route>
            <Route path="/payment/:result" element={<Protected><PaymentResult /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster theme="dark" position="bottom-right" />
          <CookieConsent />
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
